import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ObserverEmitter, { EVENTS } from '../../emitter/Observer'
import { loadCompleteScene, initLoadingScene } from '../../store/slices/menu/menu'
import { useLocation } from 'react-router-dom'


const routes = ["/home1/", "/home1"]

export const LoadingSceneGiff = () => {
	const { loadedScene } = useSelector(state => state.menu)
	const dispatch = useDispatch()
	const location = useLocation()

	ObserverEmitter.on(EVENTS.loadingCompleteScene, () => {
		dispatch(loadCompleteScene())
	});

	ObserverEmitter.on(EVENTS.initLoadingScene, () => {
		dispatch(initLoadingScene())
	});

	if (routes.includes(location.pathname)) {
		return <></>
	}

	return (
		<div className={`fixed z-50 w-full h-full flex justify-center items-center bg-black ${loadedScene && 'animate__animated  animationLoading'}`} >
			<img className="w-10 h-10" src="https://i.gifer.com/origin/34/34338d26023e5515f6cc8969aa027bca_w200.gif" alt="" />
		</div>
	)
}
